module.exports = __webpack_public_path__ + "/login_ui/img/ky-28799ec59a0f03d0f94be1d92ede3075.svg";